import { useStaticQuery, graphql } from "gatsby"

const useCategories = () => {
  const { allWpCategory } = useStaticQuery(graphql`
    query Categories {
      allWpCategory(
        sort: {name: ASC}
        filter: { slug:{ne:"uncategorized"}}
      )
      {
        nodes {
          name
          slug
        }
      }
    }
  `)

  return allWpCategory.nodes 
}

export default useCategories